export default [
  '/images/machining_photos/1.webP',
  '/images/machining_photos/2.webP',
  '/images/machining_photos/3.webP',
  '/images/machining_photos/4.webP',
  '/images/machining_photos/5.webP',
];
